<div class="page">
  <header class="page-header">
    <div class="title">
      <h1>{{ 'companies.title' | translate }}</h1>
      @if (!loading() || total()) {
        <span class="subtitle">{{ 'companies.count' | translate: { count: total() } }}</span>
      }
    </div>

    <div class="toolbar">
      <app-search-bar [value]="query" [width]="260" (searchText)="search($event)"></app-search-bar>
      <lib-button icon="add" [text]="'companies.add' | translate" (click)="drawer.set({ id: null })"></lib-button>
    </div>
  </header>

  @if (loading() && !companies().length) {
    <app-spinner></app-spinner>
  } @else if (failed()) {
    <div class="state">
      <lib-no-data icon="cloud_off" message="companies.errors.load"></lib-no-data>
      <lib-button color="secondary" icon="refresh" [text]="'companies.retry' | translate" (click)="load()"></lib-button>
    </div>
  } @else if (!companies().length) {
    <div class="state">
      <lib-no-data icon="domain" [message]="query ? 'companies.no_result' : 'companies.empty'"
        [description]="query ? '' : 'companies.empty_desc'">
      </lib-no-data>
    </div>
  } @else {
    <ul class="company-list" [class.refreshing]="loading()">
      @for (company of companies(); track company.id) {
        <li class="company" [class.expanded]="expandedId() === company.id">
          <div class="company-row">
            <button type="button" class="row-main" [attr.aria-expanded]="expandedId() === company.id" (click)="toggle(company)">
              <app-company-logo [name]="company.name" [logo]="company.logo" [size]="44"></app-company-logo>

              <span class="identity">
                <span class="name">{{ company.name }}</span>
                @if (company.allProjects) {
                  <span class="badge">{{ 'companies.all_access' | translate }}</span>
                }

                @if (company.id === currentId()) {
                  <span class="badge active">{{ 'companies.active' | translate }}</span>
                }
              </span>

              <span class="stats">
                <span class="stat" [matTooltip]="'companies.projects' | translate">
                  <mat-icon>folder</mat-icon>{{ company.projectsCount }}
                </span>

                <span class="stat" [matTooltip]="'companies.users' | translate">
                  <mat-icon>group</mat-icon>{{ company.usersCount }}
                </span>

                <span class="stat" [matTooltip]="'companies.tenants' | translate">
                  <mat-icon>category</mat-icon>{{ company.tenantsCount }}
                </span>
              </span>

              <mat-icon class="chevron">expand_more</mat-icon>
            </button>

            <div class="row-actions">
              @if (company.id === currentId()) {
                <lib-button color="none" textColor="primary" icon="check_circle" [tooltip]="'companies.active' | translate" [disabled]="true">
                </lib-button>
              } @else {
                <lib-button color="none" textColor="muted" icon="radio_button_unchecked" [tooltip]="'companies.activate' | translate"
                  (click)="activate(company)">
                </lib-button>
              }

              <lib-button color="none" textColor="muted" icon="category" [tooltip]="'companies.open_tenants' | translate"
                (click)="openTenants(company)">
              </lib-button>

              <lib-button color="none" textColor="muted" icon="edit" [tooltip]="'companies.edit' | translate"
                (click)="drawer.set({ id: company.id })">
              </lib-button>
              @if (!company.allProjects) {
                <lib-button color="none" textColor="danger" icon="delete" [tooltip]="'form.delete' | translate"
                  (click)="remove(company)">
                </lib-button>
              }
            </div>
          </div>

          @if (expandedId() === company.id) {
            <div class="tenants">
              @if (details()[company.id]; as detail) {
                @for (tenant of detail.tenants; track tenant.id) {
                  <div class="tenant">
                    <span class="tenant-icon" [style.--tenant-color]="tenant.color">
                      <mat-icon>{{ tenant.icon }}</mat-icon>
                    </span>
                    <div class="tenant-body">
                      <span class="tenant-name">{{ tenant.name }}</span>

                      <span class="tenant-projects">
                        @for (project of tenant.projects; track project.id; let last = $last) {
                          {{ project.name }}{{ last ? '' : ' · ' }}
                        } @empty {
                          {{ 'companies.no_projects' | translate }}
                        }
                      </span>
                    </div>
                    
                    <span class="tenant-count">{{ tenant.projects.length }}</span>
                  </div>
                } @empty {
                  <p class="no-tenant">{{ 'companies.no_tenants' | translate }}</p>
                }
              } @else {
                <app-spinner></app-spinner>
              }
            </div>
          }
        </li>
      }
    </ul>

    @if (total() > pageSize()) {
      <mat-paginator [length]="total()" [pageIndex]="pageIndex()" [pageSize]="pageSize()" [pageSizeOptions]="[20, 50, 100]"
        (page)="onPage($event)">
      </mat-paginator>
    }
  }
</div>

@if (drawer(); as open) {
  <app-company-drawer [companyId]="open.id" (closed)="drawer.set(null)" (saved)="onSaved()"></app-company-drawer>
}
